import React from 'react';
import { Clock } from 'lucide-react';

const RecoCard = ({ reco, t }) => {
  const level = reco.confidence >= 80 ? 'high' : reco.confidence >= 50 ? 'med' : 'low';

  return (
    <div className="reco-card">
      <div className="reco-header">
        <div className="reco-asset">
          <div className="reco-icon">{reco.ticker?.slice(0, 2)}</div>
          <div>
            <div className="reco-ticker">{reco.ticker}</div>
            <div className="reco-name">{reco.name}</div>
          </div>
        </div>
        <span className={`reco-type ${reco.type}`}>{reco.type}</span>
      </div>
      <div className="reco-body">
        <div className="reco-metrics">
          <div className="reco-metric">
            <span className="metric-label">{t.app.entry}</span>
            <span className="metric-value entry">${reco.entry?.toLocaleString()}</span>
          </div>
          <div className="reco-metric">
            <span className="metric-label">{t.app.target}</span>
            <span className="metric-value target">${reco.target?.toLocaleString()}</span>
          </div>
          <div className="reco-metric">
            <span className="metric-label">{t.app.stop}</span>
            <span className="metric-value stop">${reco.stop?.toLocaleString()}</span>
          </div>
          <div className="reco-metric">
            <span className="metric-label">{t.app.riskMax}</span>
            <span className="metric-value risk">{reco.riskPct}%</span>
          </div>
        </div>
        <div className="confidence">
          <div className="confidence-header">
            <span className="confidence-label">{t.app.confidence}</span>
            <span className={`confidence-value ${level}`}>{reco.confidence}%</span>
          </div>
          <div className="confidence-bar">
            <div className={`confidence-fill ${level}`} style={{ width: `${reco.confidence}%` }} />
          </div>
        </div>
      </div>
      <div className="reco-footer">
        <div className="reco-horizon"><Clock size={14} /> {reco.horizon}</div>
        <div className="reco-date">{reco.date}</div>
      </div>
    </div>
  );
};

export default RecoCard;
